module.exports = __webpack_public_path__ + "img/uy.a4931745.svg";